import * as HeaderServices from '../header-services/header-services';
import { updateBasketTotal, updateQuickBasketCount } from '../quick-basket/quick-basket-ui';
import { updateWishlistCount } from '../wishlist/wishlist-ui';

export async function updateData(cacheBuster = false) {
    const data = await HeaderServices.getData(cacheBuster);
    updateDataFromData(data);
}

export async function updateDataFromData(data) {
    updateWishlistCount({cacheBuster: true});
    updateQuickBasketCount(-1,false);
    updateBasketTotal();
    if (data.isLoggedIn) {
        setIsLoggedInStates(selectAllLoggedInStatesElms());
        return;
    }
    setIsLoggedOutStates(selectAllLoggedInStatesElms());
}

// Needed because bootstrap breakpoint will override lower classes
const hiddenSelectors = ['d-none', 'd-sm-none', 'd-md-none', 'd-lg-none', 'd-xl-none', 'd-xxl-none'];

const hideElement = e => e.classList.add(...hiddenSelectors);
const showElement = e => e.classList.remove(...hiddenSelectors);


function setIsLoggedInStates(elements) {

    elements.isVisibleLoggedIn.forEach(showElement);
    elements.isHiddenLoggedIn.forEach(hideElement);

    elements.isVisibleLoggedOut.forEach(hideElement);
    elements.isHiddenLoggedOut.forEach(showElement);

}

function setIsLoggedOutStates(elements) {
    elements.isVisibleLoggedIn.forEach(hideElement);
    elements.isHiddenLoggedIn.forEach(showElement);
    elements.isVisibleLoggedOut.forEach(showElement);
    elements.isHiddenLoggedOut.forEach(hideElement);
}

function selectAllLoggedInStatesElms() {

    return {
        isVisibleLoggedIn: document.querySelectorAll('.is-visible-loggedin'),
        isHiddenLoggedIn: document.querySelectorAll('.is-hidden-loggedin'),
        isVisibleLoggedOut: document.querySelectorAll('.is-visible-loggedout'),
        isHiddenLoggedOut: document.querySelectorAll('.is-hidden-loggedout')
    };

}